var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VLayout',{attrs:{"upline":"","title":_vm.$t('cookies.title')}},[_c('VMarkdownView',{staticClass:"text-justify",attrs:{"mdtext":_vm.$t('cookies.legal_text')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }